export default __webpack_public_path__ + "static/media/up-arrow.d095ec1c.svg";